module.exports = __webpack_public_path__ + "static/media/rotaClock.83d5d2a7.svg";